import { render, staticRenderFns } from "./CChartSalesPerMonth.vue?vue&type=template&id=d5396856"
import script from "./CChartSalesPerMonth.vue?vue&type=script&lang=js"
export * from "./CChartSalesPerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports